import * as React from 'react'

const SendPaperRocketSvg = ({
  width,
  className,
}: {
  width: number
  className?: string
}) => (
  <svg
    className={className}
    width={width}
    height={width}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.7241 12.5333L19 4M10.7241 12.5333L13.8276 20L19 4M10.7241 12.5333L4 9.33333L19 4"
      stroke="currentColor"
    />
  </svg>
)

export default SendPaperRocketSvg
